/**
 * Hana Shishufuku — Product description shipping date normalizer
 * v2 — handles multiple HTML patterns (label-then-date, date-in-h3, etc.)
 *
 * Replaces variable shipping date text in any product description with the
 * standard message "ご注文から7〜10営業日で発送", regardless of the
 * underlying HTML structure (h2/h3/p/span/strong nesting).
 */
(function () {
  'use strict';

  var STANDARD_TEXT = 'ご注文から7〜10営業日で発送';
  var WARM_ACCENT = 'rgba(140, 106, 79, 1)';

  // Heuristic: an element is a "shipping date" if its visible text mentions
  // 発送 / 発注 / X月 / 上旬・中旬・下旬, AND it is short, AND it isn't part
  // of an unrelated coloured note like 「試着後の返品交換可能」.
  function looksLikeShippingDate(text) {
    if (!text) return false;
    var t = text.trim();
    if (t.length === 0 || t.length > 60) return false;
    if (/返品|交換|可能/.test(t)) return false;          // exclude 返品/交換 colored notes
    if (t === STANDARD_TEXT) return false;                // already normalized
    return (
      /発送/.test(t) ||
      /発注/.test(t) ||
      /\d{1,2}\s*月\s*[上中下]?\s*旬/.test(t) ||
      /\d{1,2}\s*\/\s*\d{1,2}/.test(t)
    );
  }

  function replaceContent(el) {
    // Replace the visible text while preserving the element itself.
    // Strip any nested <strong> / <br> children to keep the result clean.
    el.textContent = STANDARD_TEXT;
    el.style.color = WARM_ACCENT;
  }

  function normalize() {
    // Match BOTH the old in-info-column description AND the new full-width
    // editorial story body (.hana-story-editorial__body)
    var descriptions = document.querySelectorAll(
      '.product__description, .hana-story-editorial__body'
    );
    if (!descriptions.length) return;

    descriptions.forEach(function (desc) {
      if (desc.dataset.shippingNormalized === 'true') return;

      // Pass 1: any coloured span that looks like a shipping date
      var colouredSpans = desc.querySelectorAll('span[style*="color"]');
      var matchedAny = false;
      colouredSpans.forEach(function (span) {
        if (looksLikeShippingDate(span.textContent)) {
          replaceContent(span);
          matchedAny = true;
        }
      });

      // Pass 2: standalone h2/h3/h4 whose text matches a date pattern
      // (some products put the date directly in the heading without a span)
      var headings = desc.querySelectorAll('h2, h3, h4');
      headings.forEach(function (h) {
        var t = (h.textContent || '').trim();
        // Skip if the heading is the LABEL itself "【発送予定日】" — we want
        // to replace the DATE that follows, not the label.
        if (/^【?\s*発送予定日?\s*】?$/.test(t)) return;
        if (looksLikeShippingDate(t)) {
          replaceContent(h);
          matchedAny = true;
        }
      });

      // Pass 3: paragraphs that contain a date pattern (without a coloured span)
      // Often the layout is <p><strong>【発送予定日】</strong></p><p>X月上旬…</p>
      if (!matchedAny) {
        var paragraphs = desc.querySelectorAll('p');
        paragraphs.forEach(function (p) {
          var t = (p.textContent || '').trim();
          if (/^【?\s*発送予定日?\s*】?$/.test(t)) return;     // pure label — keep
          if (/^[ーー\-—=・]+$/.test(t)) return;                // separator — keep
          if (looksLikeShippingDate(t)) {
            replaceContent(p);
          }
        });
      }

      desc.dataset.shippingNormalized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', normalize);
  } else {
    normalize();
  }

  // Re-run after Shopify section reloads (variant change, theme editor, etc.)
  document.addEventListener('shopify:section:load', normalize);
})();
